import { SimpleGrid, Stack, useMantineTheme } from '@mantine/core'
import React from 'react'
import { SectionPlaceholder } from 'src/components'
import { CapabilitiesContent, MenuLinks } from 'src/content'
import Fade from 'react-reveal/Fade'

import { ServiceCard } from './components'
import { useMediaQuery } from '@mantine/hooks'

export interface CapabilitiesProps {}

export const Capabilities: React.FC<CapabilitiesProps> = () => {
  const { Capabilities } = CapabilitiesContent
  const theme = useMantineTheme()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.md})`)
  const { MenuAnchor } = MenuLinks

  return (
    <SectionPlaceholder
      // title="Capabilities"
      title="What I'm Trusted With"
      subTitle="import {Capabilities} from Experience;"
      anchorClassName={MenuAnchor.Capabilities}
    >
      <Stack align="apart" mt={80}>
        <Fade bottom>
          <SimpleGrid
            cols={2}
            spacing={isMobile ? 80 : 120}
            breakpoints={[{ maxWidth: 'md', cols: 1, spacing: 50 }]}
            sx={{ placeItems: 'center', marginInline: isMobile ? 50 : 0 }}
          >
            <ServiceCard {...Capabilities.mobile} />
            <ServiceCard {...Capabilities.web} />
            <ServiceCard {...Capabilities.design} mediaCustomStyles={{ paddingTop: 28 }} />
            <ServiceCard {...Capabilities.project} mediaCustomStyles={{ padding: 20 }} />
          </SimpleGrid>
        </Fade>
      </Stack>
    </SectionPlaceholder>
  )
}
